// This file for formatting  columns and rows. Color, text-align font-size, font-family etc.
import { EncoloredField, textColorOptions, tableField } from '../models/type';

// this function for coloring columns and adding labelmetadata text align
export function createColumnStyleObject(labelMetaData, encoloredFields: EncoloredField[], type) {
	function setTextAlign(key) {
		const textAlign = labelMetaData[key]?.align;
		if (textAlign) {
			return `text-align:${textAlign};`;
		} else {
			return `text-align:left;`;
		}
	}

	function setBackgroundColor(key) {
		let style = `background-color:var(--main-table-th-color);`; // this color will change with dynamic value
		if (encoloredFields) {
			const selectedField = encoloredFields.find((field: EncoloredField) => field.key === key);
			if (selectedField) {
				if (type === tableField.header) {
					style = `background-color:${selectedField.colorHeader};`;
					style += setTextColor(selectedField.colorHeader);
				} else {
					style = `background-color:${selectedField.colorCell};`;
					style += setTextColor(selectedField.colorCell);
				}
			}
		}
		return style;
	}

	function setTextColor(bgColor) {
		let style;
		if (bgColor === '' || bgColor === '#f7f7f7') {
			style = `color:${textColorOptions.basic};`;
		} else {
			style = `color:${textColorOptions.colored};`;
		}
		return style;
	}

	function resultedStyle(key) {
		let style = setTextAlign(key);
		style += setBackgroundColor(key);
		return style;
	}

	return resultedStyle;
}

export function createGeneralStyleString(generalSettings: { fontSize: string; fontStyle: string }): string {
	if (generalSettings) {
		const { fontSize, fontStyle } = generalSettings;
		return `font-size:${fontSize}!important;`;
	}
	return 'font-size:12px; font-family:Poppins,sans-serif!important;';
}
